import axios from 'axios';

const API_URL = process.env.VUE_APP_API_PATH + '/';

class AuthService {
    login(username: string, password: string) {
        console.log("logging in")
        return axios
            .post(API_URL + 'login', {
                username,
                password
            }, {
                withCredentials: true
            })
    }

    getUser() {
        return axios.get(API_URL + "api/username", {withCredentials: true})
            .then(response => {
                return response.data;
            })
    }

    logout() {
        return axios
            .post(API_URL + 'logout', {}, {
                withCredentials: true
            })
    }


}

export default new AuthService();
